var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.visible,"persistent":"","max-width":"180"}},[_c('v-card',[_c('v-card-text',{staticClass:"pa-4 d-flex justify-center align-center"},[_c('v-progress-circular',{staticClass:"mr-2",attrs:{"size":"24","width":"3","indeterminate":"","color":"primary"}}),_vm._v("\n        Carregando...\n      ")],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }